export default __webpack_public_path__ + "static/media/home-feed-image-coming-soon.185c3d69.jpg";